export default __webpack_public_path__ + "static/media/SJ.6d8f6e66.svg";